import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-211895ea"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "ss-wrap"
};
const _hoisted_2 = {
  class: "ss-title"
};
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = {
  key: 0,
  class: "ss-tip"
};
const _hoisted_5 = {
  key: 1,
  class: "ss-tip"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_search = _resolveComponent("van-search");
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_van_cell = _resolveComponent("van-cell");
  const _component_van_loading = _resolveComponent("van-loading");
  const _component_van_empty = _resolveComponent("van-empty");
  const _component_van_popup = _resolveComponent("van-popup");
  return _openBlock(), _createBlock(_component_van_popup, {
    show: $options.innerShow,
    "onUpdate:show": _cache[2] || (_cache[2] = $event => $options.innerShow = $event),
    position: "bottom",
    closeable: "",
    round: "",
    style: {
      height: '70%'
    },
    onOpen: $options.onOpen,
    onClose: $options.onClose
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString($props.title), 1), _createVNode(_component_van_search, {
      modelValue: $data.keyword,
      "onUpdate:modelValue": [_cache[0] || (_cache[0] = $event => $data.keyword = $event), $options.onKeywordInput],
      placeholder: $props.placeholder,
      onSearch: $options.onSearch
    }, null, 8, ["modelValue", "placeholder", "onUpdate:modelValue", "onSearch"]), _createElementVNode("div", {
      ref: "bodyEl",
      class: "ss-body",
      onScrollPassive: _cache[1] || (_cache[1] = (...args) => $options.onScroll && $options.onScroll(...args))
    }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.pageList, item => {
      return _openBlock(), _createBlock(_component_van_cell, {
        key: item.value,
        class: _normalizeClass(["ss-cell", {
          'ss-cell--active': $options.isActive(item)
        }]),
        onClick: $event => $options.onPick(item)
      }, {
        title: _withCtx(() => [_createElementVNode("span", {
          class: "ss-text",
          innerHTML: $options.highlight(item.text)
        }, null, 8, _hoisted_3)]),
        value: _withCtx(() => [$options.isActive(item) ? (_openBlock(), _createBlock(_component_van_icon, {
          key: 0,
          name: "success",
          color: "#1989fa"
        })) : _createCommentVNode("", true)]),
        _: 2
      }, 1032, ["class", "onClick"]);
    }), 128)), $data.loading ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_van_loading, {
      size: "16px"
    }, {
      default: _withCtx(() => [_createTextVNode("加载中...")]),
      _: 1
    })])) : $options.pageList.length && $options.pageList.length >= $options.matchList.length ? (_openBlock(), _createElementBlock("div", _hoisted_5, " 没有更多了 ")) : _createCommentVNode("", true), !$data.loading && !$options.pageList.length ? (_openBlock(), _createBlock(_component_van_empty, {
      key: 2,
      description: "没有匹配的数据"
    })) : _createCommentVNode("", true)], 544)])]),
    _: 1
  }, 8, ["show", "onOpen", "onClose"]);
}